import React from 'react';

import { PrivacyPolicyWebPage } from '../web/PrivacyPolicyWebPage';

/** Auth veya ana yığında tam ekran gizlilik metni. */
export function PrivacyPolicyScreen() {
  return <PrivacyPolicyWebPage showHomeLink={false} />;
}
